import { CheckBolderIcon, CrossBoldIcon, NavigationTimeIcon } from '@capsicum/common-web/icons';
import { useVerifyModal } from '@capsicum/features/nc-onboarding/shared';
import styled, { useTheme } from 'styled-components';

export const useStepVerifyIcon = () => {
	const { colors } = useTheme();
	const { getStepIcon, isStepDisabled } = useVerifyModal();

	const getStepVerifyIcon = (level: 2 | 3) => {
		const stepIcon = getStepIcon(level);

		if (Number.isInteger(stepIcon)) {
			return <S.Circle $isFilled={isStepDisabled(level)}>{stepIcon}</S.Circle>;
		}

		if (stepIcon === 'completed') {
			return (
				<S.Circle $hasIcon $isFilled>
					<CheckBolderIcon height={12} width={12} />
				</S.Circle>
			);
		}

		if (stepIcon === 'underReview') {
			return (
				<S.Circle $backgroundColor={colors.icons.pending.enabled} $hasIcon $isFilled>
					<NavigationTimeIcon height={12} width={12} />
				</S.Circle>
			);
		}

		return (
			<S.Circle $backgroundColor={colors.icons.error.enabled} $hasIcon $isFilled>
				<CrossBoldIcon height={12} width={12} />
			</S.Circle>
		);
	};

	return { getStepVerifyIcon };
};

namespace S {
	export const Circle = styled.div<{
		$backgroundColor?: string;
		$hasIcon?: boolean;
		$isFilled: boolean;
	}>`
		background-color: ${({ $backgroundColor, $isFilled, theme }) =>
			$backgroundColor ??
			($isFilled ? theme.colors.backgrounds.brand.enabled : theme.colors.backgrounds.main.container)};
		${({ theme }) => theme.border.radius.circle};
		border-color: ${({ $backgroundColor, theme }) => $backgroundColor || theme.colors.borders.brand.enabled};
		border-style: solid;
		border-width: ${({ theme }) => theme.border.width.small};
		color: ${({ $isFilled, theme }) =>
			$isFilled ? theme.colors.text.main.inverse : theme.colors.text.brand.enabled};
		display: inline-block;
		${({ theme }) => theme.fonts.text.caption1};
		padding: ${({ $hasIcon, theme }) => ($hasIcon ? '5px' : `4px ${theme.sizing.xxxsmall}`)};
		position: relative;
	`;
}
